<template>
  <DataTable url="folder_structures" edit-url="edit-template-form" />
</template>
<script>
import { mapGetters } from "vuex";
import DataTable from "@/components/DataTable.vue";
export default {
  name: "template-index",
  emits: ["setBreadcrumb"],
  components: { DataTable },
  data() {
    return {
      breadcrumb: [{ text: "Plantillas", link: { name: "templates" } }],
    };
  },
  created() {
    this.$emit("setBreadcrumb", this.breadcrumb);
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
  },
};
</script>
